// The files ATTACHED to the thing the universal input box is composing (busy-my-web#444 / #445).
//
// The box owns the attachment state — `quickFiles` (everything uploaded onto the Work-board) and
// `attachedFileIds` (the picked subset) live in SmartBox.vue, because attaching is one of the
// things the composer DOES. This module exists for the one surface that cannot be reached by a
// prop: the Timeline rail on the other side of the page, whose creation item lists the selection
// ("Ready when you are / 2 items selected", frame 40008539:201115).
//
// So it is a REPORT, not a second source of truth. The box writes what is attached; the rail reads
// it through `focusedSession/timelineItem`, which is where the session's one item is already built.
// An uploaded file that has not been selected never arrives here at all — that is the whole of
// #445 on this surface, and the reason the rail can draw everything it is given.
//
// "Clear selection" is the other direction, and it is an ASK rather than a write: the rail bumps
// `clearAt`, the box watches it and un-attaches everything. Two owners of one selection is how a
// file ends up attached on one surface and not on the other.

export const state = {
  // [{ tempId, name, contentType, webContentLink }] — the composer's own shape, trimmed to what the
  // rail draws. `lib/selectedFiles.js` turns it into rows.
  files: [],
  // How many times "Clear selection" has been pressed. A counter, not a flag: two presses in a row
  // are two requests, and the box has to hear both.
  clearAt: 0,
}

export const getters = {
  files: (s) => s.files,
  count: (s) => s.files.length,
  clearAt: (s) => s.clearAt,
}

export const mutations = {
  SET_FILES(s, files) { s.files = Array.isArray(files) ? files : [] },
  ASK_CLEAR(s) { s.clearAt += 1 },
}

export const actions = {
  /** The box reporting what is attached right now. */
  set({ commit }, files) { commit('SET_FILES', files) },
  /** The rail's "Clear selection" — answered by the box (see `clearAt`). */
  clear({ commit }) { commit('ASK_CLEAR') },
}
